import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@shadowhealth/oidc-login";

export default function PrivateRoute({ children }) {
  const auth = useAuth();
  const isLoggedIn = auth?.user;
  return isLoggedIn ? children : <Navigate to="/" />;
}
